import React, { useState, useEffect } from "react";
import withStyles from "@mui/styles/withStyles";
import CourseFind from 'components/courses/course-find'
import NewCourses from "components/courses/new-courses";
import NextAppointment from "components/appointments/next-appointment";
import { useHistory } from "react-router-dom";
import SuggestedAppointment from "components/appointments/suggest-appointment";
import { GET_ACCEPTED_GENERAL_TERMS_AND_PRIVACY, GET_PHARMACY_PROJECTS, GET_RECOMMENDED_SECTION, CURRENT_USER_QUERY, GET_OPEN_GIVEAWAYS } from "queries/queries";
import { GET_NEXT_APPOINTMENT, GET_ADVERT } from "queries/queries";
import { useQuery } from "@apollo/client";
import Loading from "components/loading";
import Error from "components/error";
import useMakeScrollable from "custom_hooks/make-scrollable";
import SurveyBox from '../Surveys/SurveyBox'
import { useSurveyDetail } from "components/Surveys/QuestionFlow/QuestionContext";
import AcceptDataModal from "./home-data-modal";
import BannerModal from './home-banner-modal';
import infoIcon from '../../assets/images/info_icon.png';
import NextLessonCard from 'components/lection/next-section-item';
import GiveawaySlider from 'components/giveaway/giveaway-slider';
import { useMutation } from '@apollo/client';
import { CREATE_DEVICE_TOKEN } from 'queries/mutations';
import hardcodedBannerImage from "../../assets/images/aposphaere_Expo.png"
import { GET_CAMPAIGNS_WITH_EXISITING_CODES_QUERY, GET_MY_CAMPAIGNS_QUERY } from "queries/queries";

const styles = (theme) => ({
  root: {
    marginBottom: '85px',
    paddingLeft: '15px',
    paddingRight: '15px',
    display: 'flex', 
    flexDirection: 'column' as const,
    gap: '16px'
  },
});

const Home = ({ classes }) => {
  const [showBanner, setShowBanner] = useState(false);
  let history = useHistory();
  useMakeScrollable();
  const { loading, error, data } = useQuery(GET_PHARMACY_PROJECTS, {
    fetchPolicy: "no-cache",
  });

  const appointment = useQuery(GET_NEXT_APPOINTMENT, {
    fetchPolicy: "no-cache",
  });

  const advert = useQuery(GET_ADVERT, {
    fetchPolicy: "no-cache",
  });

  const acceptedTermsAndPolicies = useQuery(GET_ACCEPTED_GENERAL_TERMS_AND_PRIVACY, {
    fetchPolicy: "no-cache",
  });

  const recommendedSection = useQuery(GET_RECOMMENDED_SECTION, {
    fetchPolicy: "no-cache",
  });

  const updateGeneralTerms = acceptedTermsAndPolicies.data?.currentUser?.updateGeneralTerms
  const updatePrivacy = acceptedTermsAndPolicies.data?.currentUser?.updatePrivacy

  const banner = advert?.data?.getAdvert?.imageUrl
  const link = advert?.data?.getAdvert?.link
  const mandatoryText = advert?.data?.getAdvert?.mandatoryText
  const nextSection = recommendedSection?.data?.nextRecommendedSection

  const user = useQuery(CURRENT_USER_QUERY, {
      fetchPolicy: "no-cache",
    });

  const giveaway = useQuery(GET_OPEN_GIVEAWAYS, {
      fetchPolicy: "no-cache",
  });

   const openGiveaways = giveaway?.data?.getOpenGiveaways;
  const { surveys } = useSurveyDetail()

const [createDeviceToken] = useMutation(CREATE_DEVICE_TOKEN, {
  onCompleted({ deviceToken }) {
    console.log("Creating device token in the backend succeeded");
  },
  onError(error) {
    console.error("Creating device token in the backend failed:", error);
  },
});

useEffect(() => {
  const deviceToken = localStorage.getItem("deviceToken");
  if (!deviceToken) return; 

  if (typeof deviceToken !== "string") return;

    const isLikelyJSON = deviceToken.startsWith("{") || deviceToken.startsWith("[");
    const tooShort = deviceToken.length < 40;
    const hasSpace = deviceToken.includes(" ");

    if (isLikelyJSON || tooShort || hasSpace) {
      return;
    }

  createDeviceToken({
    variables: { token: deviceToken },
  });
  }, []); 

  const myCouponsResult = useQuery(GET_CAMPAIGNS_WITH_EXISITING_CODES_QUERY, {
    fetchPolicy: "no-cache",
  });

  const myCampaignsResult = useQuery(GET_MY_CAMPAIGNS_QUERY, {
    fetchPolicy: "no-cache",
  });


  if (loading) return <Loading />;
  if (error) return <Error />;

  const nextAppointment = appointment?.data?.getNextAppointment
  const isNext = !!nextAppointment
  const project = isNext ? nextAppointment : data.getPharmacyProjects[0]
  const currentUserName = user?.data?.currentUser?.firstName || ''

  const myCoupons = myCouponsResult.data?.purchasableCampaigns.couponType || [];
  const myInstant = myCouponsResult.data?.purchasableCampaigns.instantType || [];
  const purchasableCoupon = [...myCoupons, ...myInstant].find(
    (coupon) => String(coupon.id) === "236"
  );

  const myOwnedCoupons = myCampaignsResult.data?.myCampaigns.couponType || [];
  const myOwnedInstant = myCampaignsResult.data?.myCampaigns.instantType || [];
  const ownedCoupon = [...myOwnedCoupons, ...myOwnedInstant].find(
    (coupon) => String(coupon.id) === "236"
  );

  const hardcodedCoupon = purchasableCoupon || ownedCoupon;
  const isOwnedCoupon = !purchasableCoupon && !!ownedCoupon;

  return (
    <div
      className={`${classes.root} scrollable`}
      data-testid="home"
    >
      <AcceptDataModal terms={updateGeneralTerms} privacy={updatePrivacy}/>
      <BannerModal showBanner={showBanner} setShowBanner={setShowBanner} text={mandatoryText}/>
      <CourseFind text={`Hallo, ${currentUserName}`}/>
      <NewCourses />
      <NextLessonCard
        section={nextSection}
        onClick={() =>  history.push(`/course_details/${nextSection.courseId}`)}
      />
      {surveys.length > 0 && <SurveyBox surveys={surveys}/>}
      {isNext && (
        <NextAppointment 
          next={isNext}
          project={project}
        />
      )}
      {project && !isNext && (
        <SuggestedAppointment 
        onClick={() => history.push('/appointments-suggestion')}
        next={isNext}
        project={project}
      />
      )} 
      <GiveawaySlider
        giveaways={openGiveaways}
      />
      {link ? (
        <a href={link} target="_blank" className="home-banner-container">
          <img className="home-banner" src={banner} />
          {!!mandatoryText && (
            <button
              className="home-button"
              onClick={(event) => {
                event.stopPropagation();
                setShowBanner(true);
              }}
            >
              <img src={infoIcon} alt="Info" />
            </button>
          )}
        </a>
      ) : (
        (banner && <div className="home-banner-container">
          <img className="home-banner" src={banner} />
          {!!mandatoryText && (
            <button
              className="home-button"
              onClick={(event) => {
                event.stopPropagation();
                setShowBanner(true);
              }}
            >
              <img src={infoIcon} alt="Info" />
            </button>
          )}
        </div>)
      )}
    </div>
  );
};

export default withStyles(styles)(Home);
